import { IDevice } from '@/types/model'
import { DeviceType } from '@/types/api'
// DEPRECATED: Unused currently
interface IErrorModalData {
  /** when error occurs, this function should call all functions in array, and clean the function array */
  retry: null | (() => void)
  /** function array whose functions should be called again by retry() */
  functions: Array<() => void>
}
export interface GeometrySize {
  width: number,
  height: number,
}

export interface State {
  // errorModal: {
  //   api: IErrorModalData,
  //   network: IErrorModalData
  // }
  networkError: boolean,
  windowSize: GeometrySize
}

// ================================================
// Main
// ================================================
const thisState: State = {
  networkError: false,
  windowSize: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
}

const getters = {

}

const mutations = {
  assignNetworkError (state: State, newVal: boolean) {
    state.networkError = newVal
  },
  assignWindowSize (state: State, newVal: GeometrySize) {
    Object.assign(state.windowSize, newVal)
  },
}

const actions = { }

export default {
  namespaced: true,
  state: thisState,
  getters,
  mutations,
  actions
}
